import axios from 'axios';

import { createAuthHeaders } from './auth';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    const headers = createAuthHeaders();
    config.headers.set(headers);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const message = error.response.data?.message || '서버 오류가 발생했습니다.';
      return Promise.reject(new Error(message));
    }
    return Promise.reject(new Error('네트워크 오류가 발생했습니다.'));
  }
);
